import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=5a37ab8b&scoped=true"
import script from "./PageSettings.vue?vue&type=script&lang=ts"
export * from "./PageSettings.vue?vue&type=script&lang=ts"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=5a37ab8b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37ab8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a37ab8b')) {
      api.createRecord('5a37ab8b', component.options)
    } else {
      api.reload('5a37ab8b', component.options)
    }
    module.hot.accept("./PageSettings.vue?vue&type=template&id=5a37ab8b&scoped=true", function () {
      api.rerender('5a37ab8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/PageSettings.vue"
export default component.exports